<template>
    <div v-if="ticketData != null">
        <div class="tcheck-mobile">
            <div class="backdrop active"></div>
            <div class="modal active modal-location-top">
                <div class="ticket-check inside">
                    <div v-if="ticketData.errors && ticketData.errors.length">
                        <div class="tcheck-header">
                            <p class="tcheck-number-text">{{$t('TICKETFETCHERROR')}}</p>
                            <div class="modal-close" v-on:click="toggleTicketModal()">
                                <div class="icon-close icon-default" />
                            </div>
                        </div>
                        <div class="loto-big-num-inner small">
                            <div class="tcheck-event tcheck-event-main"
                            v-for="(error, index) of ticketData.errors"
                            :key="index">
                                {{error | parseTicketError}}
                            </div>
                        </div>
                    </div>
                    <div class="ticket-check inside" v-else>
                        <div class="tcheck-paidout" v-if="ticketData.data.payoutStatus === 'PAID' && ticketData.data.status == 'WIN'">
                            <img src="../../assets/img/icon-ticket-paidout.svg">
                            <p>{{$t('TICKETPAIDOUT')}}</p>
                        </div>
                        <div class="tcheck-header">
                            <div class="tcheck-date-content">
                                <div class="tcheck-event-status">
                                    <div class="win"
                                    v-if="ticketData.data.status == 'WIN'">
                                        <i class="icon-win iconset"></i>
                                    </div>
                                    <div class="lost"
                                    v-else-if="ticketData.data.status == 'LOST'">
                                        <i class="icon-lost iconset"></i>
                                    </div>
                                    <div class="active"
                                    v-else-if="ticketData.data.status == 'ACTIVE'
                                    || ticketData.data.status == 'PREPARED'">
                                        <i class="icon-pending iconset"></i>
                                    </div>
                                    <div class="refund"
                                    v-else-if="ticketData.data.status == 'REFUND'">
                                        <i class="icon-refund iconset"></i>
                                    </div>
                                    <div class="cancelled"
                                    v-else-if="ticketData.data.status == 'CANCELLED'">
                                        <i class="icon-cancelled iconset"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="tcheckm-dateid">
                                <p class="tcheck-number-text">{{$t('TICKETID')}}:
                                    <span class="tcheck-number">{{ticketData.data.code}}</span>
                                </p>
                                <p class="tcheck-date">{{ticketDataDateRecieved | getLocalDate}}</p>
                            </div>
                            <div class="modal-close" v-on:click="toggleTicketModal()">
                                <div class="icon-close icon-default" />
                            </div>
                        </div>
                        <div class="loto-big-num-inner small" v-if="ticketData.data.selections.data[0].codeProduct == 'LOTTO'">
                            <div class="tcheck-event tcheck-event-main">
                                <div class="tcheck-event-name">{{$t('EVENT')}}</div>
                                <div class="tcheck-event-date">{{$t('DATE')}}</div>
                                <div class="tcheck-event-status">{{$t('STATUS')}}</div>
                            </div>
                            <vue-scroll class="tcheck-events-box">
                                <div class="tcheck-event">
                                    <div class="tcheck-event-name">
                                        {{ticketData.data.selections.data[0].names['event-name'].texts[`${globals.langCode}`]}}
                                    </div>
                                    <div class="tcheck-event-date">
                                        {{ticketData.data.selections.data[0].timestampEvent | getLocalDate}}
                                    </div>

                                    <div class="tcheck-event-status">
                                        <div class="win"
                                        v-if="ticketData.data.status == 'WIN'">
                                            <i class="icon-win iconset"></i>
                                        </div>
                                        <div class="lost"
                                        v-else-if="ticketData.data.status == 'LOST'">
                                            <i class="icon-lost iconset"></i>
                                        </div>
                                        <div class="active"
                                        v-else-if="ticketData.data.status == 'ACTIVE'
                                        || ticketData.data.status == 'PREPARED'">
                                            <i class="icon-pending iconset"></i>
                                        </div>
                                        <div class="refund"
                                        v-else-if="ticketData.data.status == 'REFUND'">
                                            <i class="icon-refund iconset"></i>
                                        </div>
                                        <div class="cancelled"
                                        v-else-if="ticketData.data.status == 'CANCELLED'">
                                            <i class="icon-cancelled iconset"></i>
                                        </div>
                                    </div>
                                </div>
                            </vue-scroll>

                            <div class="tcheck-event tcheck-event-main">
                                <div class="tcheck-event-pick" v-if="ticketData.data.selections.data[0].codeProduct != 'LOTTO'">
                                    {{$t('ODDNAME')}}
                                </div>
                                <div class="tcheck-event-pick" v-else>{{$t('BALLNUM')}}</div>
                            </div>

                            <vue-scroll class="tcheck-events-box">
                                <div class="tcheck-event">
                                    <div class="tcheck-event-balls no-hover">
                                        <span
                                        v-for="(event, i) in ticketData.data.selections.data"
                                        :key="`${event.idOutcome}${i}`"
                                        v-bind:class="{'win': (event.status == 'WIN' || event.status == 'HALFWIN'),
                                        'lost': (event.status == 'LOST')}">
                                            <div v-if="event.codeProduct == 'LOTTO'" class="tcheck-event-pick-bottom">
                                                <div class="lotto-results-numbers">
                                                    <div class="results-loto-balls">
                                                        <div class="loto-number-box">
                                                            <div class="loto-big-num small" :class="event.status.toLowerCase()">
                                                                <div class="loto-ball-shadow"></div>
                                                                <div class="loto-big-num-inner small"
                                                                v-if="ticketData.data.selections.data[0].codeProduct == 'SPORT'">
                                                                    {{event.names['outcome-name'].texts[`${globals.langCode}`]}} ({{event.names['outcome-short-name'].texts[`${globals.langCode}`]}})
                                                                </div>
                                                                <div class="loto-big-num-inner small" v-else>
                                                                    {{event.names['outcome-name'].texts[`${globals.langCode}`]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else-if="event.codeProduct == 'SPORT'" class="tcheck-event-pick-bottom">
                                                <div class="lotto-results-numbers">
                                                    <div class="results-loto-balls">
                                                        <div class="loto-number-box">
                                                            <div class="loto-big-num small">
                                                                <div class="loto-big-num-inner small">
                                                                    {{event.names['outcome-name'].texts[`${globals.langCode}`]}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tcheck-event-pick" v-else-if="event.codeProduct == 'LOTTO_EXTENDED'">
                                                {{$t(event.names['outcome-name'].texts[`${globals.langCode}`].toUpperCase())}}
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </vue-scroll>
                            <template v-if="lottoResults && lottoResults.length">
                                <div class="tcheck-event tcheck-event-main">
                                    <div class="tcheck-event-pick">{{$t('TICKETCHECK_DRAWNLOTTONUMBERS')}}</div>
                                </div>
                                <vue-scroll class="tcheck-events-box">
                                    <div class="tcheck-event">
                                        <div class="tcheck-event-balls no-hover">
                                            <span
                                            v-for="event in lottoResults"
                                            :key="event">
                                                <div class="tcheck-event-pick-bottom">
                                                    <div class="lotto-results-numbers">
                                                        <div class="results-loto-balls">
                                                            <div class="loto-number-box">
                                                                <div class="loto-big-num small">
                                                                    <div class="loto-big-num-inner small">
                                                                        {{ event }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </vue-scroll>
                            </template>
                        </div> <!-- end of lotto -->
                        <div v-if="ticketData.data.selections.data[0].codeProduct === 'SPORT'
                        || ticketData.data.selections.data[0].codeProduct == 'LOTTO_EXTENDED'">
                            <vue-scroll class="tcheck-events-box">
                                <div class="mtlist-sport tcheck-event" v-for="(event, i) in ticketData.data.selections.data" :key="`${event.idOutcome}${i}`">
                                    <div class="top">
                                        <div>
                                            <div v-if="event.eventStateInitial && event.eventStateInitial.state === 'live'" class="live">{{$t('LIVEEVENT')}}</div>
                                            <div v-else class="date">{{event.timestampEvent | getLocalDate}}</div>
                                        </div>
                                        <div class="tcheck-event-fix" v-if="event.fix">
                                            <i class="icon-fix iconset"></i>
                                        </div>
                                    </div>
                                    <div class="middle">
                                        <div class="teams">
                                            <template v-if="event.codeProduct === 'SPORT'">
                                                {{event.names['t1-name'].texts[`${globals.langCode}`]}} - {{event.names['t2-name'].texts[`${globals.langCode}`]}}
                                            </template>
                                            <template v-else>
                                                {{event.nameEvent[`${globals.langCode}`]}}
                                            </template>
                                        </div>
                                    </div>
                                    <div class="bottom">
                                        <div class="left">
                                            <div class="status">
                                                <div class="tcheck-event-status mobile-event">
                                                    <div class="win"
                                                    v-if="event.status == 'WIN'">
                                                        <i class="icon-win iconset"></i>
                                                    </div>
                                                    <div class="lost"
                                                    v-else-if="event.status == 'LOST'">
                                                        <i class="icon-lost iconset"></i>
                                                    </div>
                                                    <div class="active"
                                                    v-else-if="event.status == 'ACTIVE'
                                                    || event.status == 'PREPARED'">
                                                        <i class="icon-pending iconset"></i>
                                                    </div>
                                                    <div class="refund"
                                                    v-else-if="event.status == 'REFUND'">
                                                        <i class="icon-refund iconset"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="market" v-if="event.codeProduct === 'SPORT'">
                                                <div>
                                                {{event.names['outcomegroup-name'].texts[`${globals.langCode}`] | formatSpecName(
                                                    {teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                                                    teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]},
                                                    event.specifiers)}} <!--({{event.selectionGroupShortName}})-->
                                                    <template v-if="event.attributes != null && event.attributes['has-modifier'] === '1'">
                                                    <!-- TODO check this below after betslip fix -> event.names.modifier.texts[`${globals.langCode}`] -->
                                                        ({{getModifierName(event)}}: {{
                                                            event.attributes['modifier-value'] | formatSpecName(
                                                                {
                                                                    teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                                                                    teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]
                                                                },
                                                                event.specifiers,
                                                            )
                                                        }})
                                                    </template>
                                                </div>
                                                <span class="sbvalue" v-if="event.attributes['outcome-sbv'] && event.codeProduct === 'VHORSE'">
                                                    ({{event.attributes['outcome-sbv']}})
                                                </span>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <div class="odd-name">
                                                <template v-if="event.codeProduct === 'SPORT'">
                                                    {{
                                                        event.names['outcome-name'].texts[`${globals.langCode}`] | formatSpecName({teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                                                        teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]},
                                                        event.specifiers)
                                                    }}
                                                    <!-- {{
                                                        itemOutcomeName(event) | formatSpecName({teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                                                        teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]},
                                                        event.specifiers)
                                                    }} -->
                                                </template>
                                                <template v-else>
                                                    {{event.names['outcome-name'].texts[`${globals.langCode}`] | formatSpecName(null, event.specifiers)}}
                                                </template>
                                            </div>
                                            <br>
                                            <div class="market" v-if="false"> <!-- TODO Valentino rijesi ovo pls da ima smisla na mobile-u :) -->
                                                <template v-if="event.attributes != null && event.attributes['has-modifier'] === '1'">
                                                    {{event.modifierName}}: {{
                                                        event.attributes['modifier-value'] | formatSpecName(
                                                            {
                                                                teamNameOne: event.names['t1-name'].texts[`${globals.langCode}`],
                                                                teamNameTwo: event.names['t2-name'].texts[`${globals.langCode}`]
                                                            },
                                                            event.specifiers,
                                                        )
                                                    }}
                                                </template>
                                                <template v-else>-</template>
                                            </div>
                                            <div class="oddvalue">
                                                <span :class="(event.status == 'HALFWIN'
                                                || event.status == 'HALFLOST'
                                                || event.status == 'REFUND') ? 'striked' : ''">
                                                    {{event.coeffEntry | formatOdd}}
                                                </span>
                                                <span class="odd-corrected"
                                                v-if="event.status == 'HALFWIN'
                                                || event.status == 'HALFLOST'
                                                || event.status == 'REFUND'">
                                                    {{event.coeff | formatOdd}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </vue-scroll>
                        </div> <!-- end of sport -->
                        <div v-if="ticketData.data.selections.data[0].codeProduct == 'VHORSE'">
                            <vue-scroll class="tcheck-events-box">
                                <div class="mtlist-sport tcheck-event"
                                v-for="(event, i) in ticketData.data.selections.data"
                                :key="`${event.idOutcome}${i}`">
                                    <div class="top">
                                        <div>
                                            <div class="date">{{event.timestampEvent | getLocalDate}}</div>
                                        </div>
                                    </div>
                                    <div class="middle">
                                        <div class="teams">
                                            <template v-if="event.attributes && event.attributes['daily-instance-id'] != null">
                                                ({{event.attributes['daily-instance-id']}})
                                            </template><span v-html="event.nameEvent[`${globals.langCode}`]"></span>
                                        </div>
                                    </div>
                                    <div class="bottom">
                                        <div class="left">
                                            <div class="status">
                                                <div class="tcheck-event-status mobile-event">
                                                    <div class="win"
                                                    v-if="event.status == 'WIN'">
                                                        <i class="icon-win iconset"></i>
                                                    </div>
                                                    <div class="lost"
                                                    v-else-if="event.status == 'LOST'">
                                                        <i class="icon-lost iconset"></i>
                                                    </div>
                                                    <div class="active"
                                                    v-else-if="event.status == 'ACTIVE'
                                                    || event.status == 'PREPARED'">
                                                        <i class="icon-pending iconset"></i>
                                                    </div>
                                                    <div class="refund"
                                                    v-else-if="event.status == 'REFUND'">
                                                        <i class="icon-refund iconset"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="market">
                                                <div>
                                                    {{event.names['outcomegroup-name'].texts[`${globals.langCode}`]}}
                                                    <span class="sbvalue" v-if="event.attributes['outcome-sbv']">
                                                        ({{event.attributes['outcome-sbv']}})
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <div class="odd-name">
                                                {{
                                                    event.names['outcome-name'].texts[`${globals.langCode}`] | formatSpecName(
                                                        undefined,
                                                        event.specifiers,
                                                    )
                                                }}
                                            </div>
                                            <div class="oddvalue">
                                                <span :class="(event.status == 'HALFWIN'
                                                || event.status == 'HALFLOST'
                                                || event.status == 'REFUND') ? 'striked' : ''">
                                                    {{event.coeffEntry | formatOdd}}
                                                </span>
                                                <span class="odd-corrected"
                                                v-if="event.status == 'HALFWIN'
                                                || event.status == 'HALFLOST'
                                                || event.status == 'REFUND'">
                                                    {{event.coeff | formatOdd}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </vue-scroll>
                        </div> <!-- end of vhorse -->
                        <!--- check why was this separate -->
                        <div v-if="false && ticketData.data.selections.data[0].codeProduct == 'SPORT'">
                            <div class="tcheck-info">
                                <div class="minor-info">
                                    <div class="tcheck-total-odd"
                                    v-if="ticketDataCoefficient !== null">
                                        {{$t('TOTALODD')}}: {{ticketDataCoefficient.sum | formatNum(4)}}
                                    </div>
                                    <div class="tcheck-total-events">
                                        {{$t('NUMBEROFEVENTS')}}: {{(ticketData.data.selections.data
                                        && ticketData.data.selections.data.length)
                                        ? ticketData.data.selections.data.length : '0'}}
                                    </div>
                                </div>
                                <div class="main-info">
                                    <div class="tcheck-total-stake">
                                        <span>{{$t('TOTALSTAKE')}}</span>
                                        <p>{{ticketData.data.payment.sumTotal | formatNum(2)}} {{ $getCurrencyAbbrv(paymentCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="paymentCurrency === 'HRK'">
                                                    {{getEurValue(ticketData.data.payment.sumTotal, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(ticketData.data.payment.sumTotal) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                    </div>
                                    <div v-if="bonus.achieved"
                                    class="tcheck-total-bonus">
                                        <p class="tcheckevent-bonus-percent" v-if="bonus.percentage
                                        && ticketData.data.calculationMeta.codeSystem === 'NORMAL'">
                                            {{bonus.percentage}}%
                                        </p>
                                        <span v-if="ticketData.data.calculationMeta.codeSystem === 'NORMAL'">{{$t('POTENTIALBONUS')}}</span>
                                        <span v-else class="bonus-badge">{{$t('MAX_BONUS')}}</span>
                                        <p>
                                            {{bonus.sum | formatNum(2)}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                             <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{getEurValue(bonus.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(bonus.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                    </div>
                                    <div class="tcheck-total-payout">
                                        <span>{{$t('POTENTIALPAYOUT')}}</span>
                                        <p>{{resolvedWinData.payout.sum | formatNum(2)}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                             <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="tcheck-info">
                                <div class="lotto-combinations"
                                v-if="ticketData.data.selections.data[0].codeProduct == 'LOTTO'
                                && payoutDataCalculated.combinationCount
                                && payoutDataCalculated.combinationCount > 1
                                && winPerBalls !== false">
                                    <div v-for="(win, num) in winPerBalls"
                                    :key="num" class="tcheck-total-comb">
                                        {{$t('GUESSEDNUMBERCOUNT', {num})}}: {{win.winTaxed
                                            | formatNum}} ({{win.win
                                            | formatNum}}) {{ $getCurrencyAbbrv(payoutCurrency)
                                        }}
                                         <template v-if="calculateEurConversion">
                                            <br>
                                            <template v-if="payoutCurrency === 'HRK'">
                                                {{getEurValue(win.winTaxed, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                            </template>
                                            <template v-else>
                                                {{getEurValue(win.winTaxed) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="sub-info">
                                    <div class="top">
                                        <div class="tcheck-data-item"
                                        v-if="ticketDataCoefficient !== null">
                                            <p>{{$t('TOTALODD')}}: </p>
                                            <p>{{ticketDataCoefficient.sum | formatNum(4)}}</p>
                                        </div>
                                        <template v-if="ticketData.data.calculationMeta.codeSystem !== 'NORMAL'">
                                            <div class="tcheck-data-item">
                                                <p>{{$t('SYSTEMPLAYED')}}: </p>
                                                <p>{{systemType}}</p>
                                            </div>
                                            <div class="tcheck-data-item">
                                                <p>{{$t('COMBINATIONNUMBER')}}: </p>
                                                <p>{{payoutDataCalculated.combinationCount}}</p>
                                            </div>
                                        </template>
                                        <div class="tcheck-data-item">
                                            <span class="tcheckevent-bonus-percent" >{{$t('TICKETWINTAX')}}</span> <!-- TODO Valentino insert blue text -->
                                           <p>
                                                {{resolvedWinData.taxOnPayout.sum
                                                | formatNum}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                                <template v-if="calculateEurConversion">
                                                    <br>
                                                    <template v-if="payoutCurrency === 'HRK'">
                                                        {{getEurValue(resolvedWinData.taxOnPayout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                    </template>
                                                    <template v-else>
                                                        {{getEurValue(resolvedWinData.taxOnPayout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                    </template>
                                                </template>
                                            </p>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="top"
                                    v-if="ticketData.data.payment.sumTotal !==
                                    ticketData.data.payment.sumStake">
                                        <div class="tcheck-data-item">
                                            <p>{{$t('TOTALPAYIN')}}: </p>
                                            <p>
                                                {{ticketData.data.payment.sumTotal
                                                | formatNum}} {{ $getCurrencyAbbrv(paymentCurrency) }}
                                                <template v-if="calculateEurConversion">
                                                    <br>
                                                    <template v-if="paymentCurrency === 'HRK'">
                                                        {{getEurValue(ticketData.data.payment.sumTotal, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                    </template>
                                                    <template v-else>
                                                        {{getEurValue(ticketData.data.payment.sumTotal) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                    </template>
                                                </template>
                                            </p>
                                        </div>
                                        <div class="tcheck-data-item">
                                            <p>{{$t('HANDLINGFEE')}}: </p>
                                            <p>
                                                {{ticketData.data.payment.sumHf
                                                | formatNum}} {{ $getCurrencyAbbrv(paymentCurrency) }}
                                                <template v-if="calculateEurConversion">
                                                    <br>
                                                    <template v-if="paymentCurrency === 'HRK'">
                                                        {{getEurValue(ticketData.data.payment.sumHf, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                    </template>
                                                    <template v-else>
                                                        {{getEurValue(ticketData.data.payment.sumHf) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                    </template>
                                                </template>
                                            </p>
                                        </div>
                                        <div class="tcheck-data-item">
                                            <p>{{$t('TOTALSTAKE')}}: </p>
                                            <p>
                                                {{ticketData.data.payment.sumStake
                                                | formatNum}} {{ $getCurrencyAbbrv(paymentCurrency) }}
                                                <template v-if="calculateEurConversion">
                                                    <br>
                                                    <template v-if="paymentCurrency === 'HRK'">
                                                        {{getEurValue(ticketData.data.payment.sumStake, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                    </template>
                                                    <template v-else>
                                                        {{getEurValue(ticketData.data.payment.sumStake) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                    </template>
                                                </template>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="main-info">
                                    <div class="tcheck-total-stake">
                                        <span>{{(ticketData.data.status === 'ACTIVE')
                                            ? $t('POTENTIALWIN')
                                            : $t('WIN')}}</span>
                                        <p>
                                            {{resolvedWinData.win.sum
                                            | formatNum}}  {{ $getCurrencyAbbrv(payoutCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{getEurValue(resolvedWinData.win.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(resolvedWinData.win.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                    </div>
                                    <div
                                    class="tcheck-total-bonus"
                                    v-if="bonus.achieved">
                                        <span v-if="ticketData.data.calculationMeta.codeSystem === 'NORMAL'">
                                            {{(ticketData.data.status === 'ACTIVE')
                                            ? $t('POTENTIALBONUS')
                                            : $t('BONUS')}}
                                        </span>
                                        <span v-else class="bonus-badge">{{$t('MAX_BONUS')}}</span>
                                        <!-- TODO add bonusing data here-->
                                        <div v-if="ticketData.data.calculationMeta.codeSystem === 'NORMAL' && bonus.percentage" class="bonus-badge">
                                            {{bonus.percentage}}%
                                        </div>
                                        <p>
                                            {{bonus.sum
                                            | formatNum(2)}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{getEurValue(bonus.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(bonus.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                    </div>
                                    <div class="tcheck-total-payout">
                                        <span>{{(ticketData.data.status === 'ACTIVE')
                                            ? $t('POTENTIALPAYOUT')
                                            : $t('PAYOUT')}}</span>
                                        <p v-if="ticketData.data.status === 'REFUND' && ticketData.data.paidOut === false">
                                            {{resolvedWinData.payout.sum
                                            | formatNum}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                        <p v-else-if="ticketData.data.paidOut === true">
                                            {{ticketData.data.payoutDetails.sumPayout
                                            | formatNum}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                {{getEurValue(ticketData.data.payoutDetails.sumPayout) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                            </template>
                                        </p>
                                         <p v-else-if="ticketData.data.payoutStatus === 'PAID'">
                                            {{resolvedWinData.payout.sum
                                            | formatNum}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                        <p v-else-if="ticketData.data.status === 'LOST'">
                                            {{ 0 | formatNum(2)}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{0 | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{0 | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                        <p v-else>
                                            {{resolvedWinData.payout.sum
                                            | formatNum}} {{ $getCurrencyAbbrv(payoutCurrency) }}
                                            <template v-if="calculateEurConversion">
                                                <br>
                                                <template v-if="payoutCurrency === 'HRK'">
                                                    {{getEurValue(resolvedWinData.payout.sum, true) | formatNum}} {{$getCurrencyAbbrv('EUR')}}
                                                </template>
                                                <template v-else>
                                                    {{getEurValue(resolvedWinData.payout.sum) | formatNum}} {{$t('CURRENCYABBRV_EUR')}}
                                                </template>
                                            </template>
                                        </p>
                                    </div>
                                </div>
                                <div class="tcheck-status-box is-template"
                                v-if="ticketData.data.tags.indexOf('template') !== -1">
                                    <div class="tcheck-status">{{$t('TICKETISTEMPLATE')}}</div>
                                </div>
                                <div class="tcheck-status-box is-template"
                                v-if="ticketData.data.tags.indexOf('test') !== -1">
                                    <div class="tcheck-status">
                                        {{ $t('TICKET_IS_TEST') }}
                                    </div>
                                </div>
                                <div class="tcheck-status-box is-template"
                                v-if="calculateEurConversion">
                                    <div class="tcheck-status">{{$t('EUR_FIXED_CONVERSION_RATE_NOTICE')}}</div>
                                </div>
                                <div class="tcheck-status-box ticket-barcode">
                                    <Barcode
                                    v-if="displayBarcode"
                                    :value="ticketData.data.code"
                                    format="CODE128" :width="1.25" height="50" display-value="false">
                                        Cannot render barcode
                                    </Barcode>
                                </div>
                                <div v-if="globals.publicConfig.retailTicketAsDeposit === true
                                && ticketData.data.payment.channel.codeType === 'TERMINAL'
                                && ticketData.data.payoutStatus == 'UNPAID'
                                && ticketData.data.status === 'WIN'"
                                class="d-flex align-center justify-center mt-md">
                                    <div v-if="payoutStep == 1" >
                                        <button v-on:click="startPayout" class="button button-blue button-payout">{{$t('PAYOUTTOONLINEACCOUNT')}}</button>
                                    </div>
                                    <div v-if="payoutStep == 2 && loading == false" >
                                        <input class="input-text mr-md" v-if="ticketData.data.controlCode == null" type="text" v-model="controlCode" :placeholder="$t('CONTROLCODE')">
                                        <p v-else class="notification-text text-center mb-md">{{$t('AREYOUSURE')}}</p>
                                        <button v-on:click="payouttoonl" class="button button-blue button-payout">{{$t('PAYOUTTOONLINEACCOUNT')}}</button>
                                        <p class="error-text text-center mt-sm">{{depositError}}</p>
                                    </div>
                                    <div v-if="payoutStep == 2 && loading == true" class="loading-container">
                                        <img src="../../assets/img/loading.svg">
                                    </div>
                                    <div v-if="payoutStep == 3" class="payout-success ml-lg">
                                        <img src="../../assets/img/icon-payout-success.svg">
                                        <p class="ml-sm">{{$t('FINISHEDPAYOUTTOONLINEACCOUNT')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import moment from 'moment-timezone';
import Barcode from 'vue-barcode';
import { Common } from '@om-retail/vue-common';
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'TicketModalMobile',
    data()
    {
        return {
            payoutStep: 1,
            controlCode: '',
            depositError: null,
            loading: false,
        };
    },
    components:
    {
        Barcode,
    },
    created()
    {
        const me = this;

        if (me.ticketData && me.ticketData.data && me.ticketData.data.controlCode)
        {
            me.controlCode = me.ticketData.data.controlCode;
        }
    },
    methods:
    {
        ...mapActions([
            'payouttoonline',
        ]),
        getModifierName(item)
        {
            if (item.attributes
            && item.attributes['modifier-name']
            && item.attributes['modifier-name'][this.globals.langCode])
            {
                return item.attributes['modifier-name'][this.globals.langCode];
            }

            return '';
        },
        getEurValue(val, reverse = false)
        {
            if (this.calculateEurConversion)
            {
                let eurCoeff = parseFloat(this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRate);

                if (reverse
                && this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRateReverse)
                {
                    eurCoeff = this.globals.publicConfig.hrkEurConversion.eurToHrkConversionRateReverse;
                }

                return parseFloat(val) / eurCoeff;
            }

            return 0;
        },
        async payouttoonl()
        {
            const me = this;
            try
            {
                me.loading = true;
                me.depositError = null;
                const response = await me.payouttoonline({
                    uuid: uuidv4(),
                    codeControl: me.controlCode,
                    ticketCode: me.ticketData.data.code,
                    currency: me.usedCurrency,
                });

                if (response.error)
                {
                    me.depositError = me.$t(response.code.toUpperCase());
                    return;
                }

                me.payoutStep = 3;
            }
            catch (error)
            {
                me.depositError = error.code;
            }
            finally
            {
                me.loading = false;
            }
        },
        startPayout()
        {
            const me = this;

            me.payoutStep = 2;
        },
        parseTicketBonus()
        {
            return '';
        },
        getUtcDate(date)
        {
            return moment.utc(date);
        },
        toggleTicketModal()
        {
            const me = this;
            me.$emit('toggleTicketModal');
        },
        itemOutcomeName(item)
        {
            const me = this;

            let field = 'selectionName';

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket != null)
            {
                const configField = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket;

                if (configField === 'outcomeName')
                {
                    field = 'selectionName';
                }
                else if (configField === 'outcomeShortName')
                {
                    field = 'selectionShortName';
                }
            }

            if (field === 'both')
            {
                let textOut = item.selectionName;

                if (item.selectionShortName != null)
                {
                    textOut += ` (${item.selectionShortName})`;
                }

                return textOut;
            }

            if (item[field] != null)
            {
                return item[field];
            }

            return item.selectionName;
        },
        itemMarketName(item)
        {
            const me = this;
            const formatSpecTeams = {
                teamNameOne: item.teamNames.teamNameOne,
                teamNameTwo: item.teamNames.teamNameTwo,
            };
            let field = 'selectionGroupName';

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket != null)
            {
                const configField = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket;

                if (configField === 'marketName')
                {
                    field = 'selectionGroupName';
                }
                else if (configField === 'marketShortName')
                {
                    field = 'selectionGroupShortName';
                }
            }

            if (field === 'both')
            {
                let textOut = Common.formatSpecName(item.selectionGroupName, formatSpecTeams, item.specifiers);

                if (item.selectionGroupShortName != null)
                {
                    textOut += `(${Common.formatSpecName(item.selectionGroupShortName, formatSpecTeams, item.specifiers)})`;
                }

                return textOut;
            }

            if (item[field] != null)
            {
                return Common.formatSpecName(item[field], formatSpecTeams, item.specifiers);
            }

            return Common.formatSpecName(item.selectionGroupName, formatSpecTeams, item.specifiers);
        },
    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'ticketData',
            'globals',
            'usedCurrency',
        ]),
        paymentCurrency()
        {
            return this.ticketData.data.payment.currency;
        },
        payoutCurrency()
        {
            if (this.ticketData.data.payout)
            {
                return this.ticketData.data.payout.currency;
            }

            return this.ticketData.data.payment.currency;
        },
        resolvedWinData()
        {
            if (this.ticketData.data.payoutStatus === 'PAID'
            && this.ticketData.data.payout)
            {
                return {
                    win:
                    {
                        sum: this.ticketData.data.payout.sumWin,
                    },
                    payout:
                    {
                        sum: this.ticketData.data.payout.sumPayout,
                    },
                    taxOnPayout:
                    {
                        sum: this.ticketData.data.payout.sumTaxOnPayout,
                    },
                };
            }

            return this.payoutDataCalculated;
        },
        bonus()
        {
            const me = this;
            const ticket = me.ticketData.data;
            const payoutCalc = me.payoutDataCalculated;

            const bonus = {
                achieved: false,
                sum: null,
                percentage: null,
            };

            const sumBonus = (payoutCalc.bonus != null && payoutCalc.bonus.sum != null) ? payoutCalc.bonus.sum : 0;

            const bonusAmount = (ticket.payout != null
            && ticket.payout.bonus != null
            && ticket.payout.bonus.sum != null)
                ? ticket.payout.bonus.sum
                : sumBonus;
            // TODO bonus parsing
            if (payoutCalc.appliedBonuses
            && payoutCalc.appliedBonuses.length)
            {
                // achieved
                bonus.achieved = true;

                if (ticket.calculationMeta.codeSystem === 'NORMAL')
                {
                    const [appliedBonus] = payoutCalc.appliedBonuses;
                    bonus.percentage = appliedBonus.percentage;
                }
            }

            bonus.sum = bonusAmount;
            return bonus;
        },
        fixedEvents()
        {
            const me = this;
            const { selections, calculationMeta } = me.ticketData.data;
            let fixedEvents = 0;

            for (let j = 0; j < selections.data.length; j += 1)
            {
                if (calculationMeta.ticketGroup.members.indexOf(selections.data[j].index) !== -1)
                {
                    fixedEvents += 1;
                }
            }
            return fixedEvents;
        },
        systemType()
        {
            const me = this;
            let system;
            const { calculationMeta } = me.ticketData.data;
            if (calculationMeta !== undefined)
            {
                if (calculationMeta.codeSystem === 'SYSTEM')
                {
                    system = `${calculationMeta.ticketGroup.systems.join(';')}`
                        + `/${calculationMeta.countEvent}`;
                }
                else if (calculationMeta.codeSystem === 'FIX_SYSTEM')
                {
                    system = `${calculationMeta.resolveGroups[0].systems.join(';')}`
                        + `/${calculationMeta.countEvent - me.fixedEvents}`;
                }
            }
            return system;
        },
        combinationData()
        {
            const me = this;
            let combinationData;
            const { calculationMeta } = me.ticketData.data;
            if (calculationMeta !== undefined)
            {
                if (calculationMeta.codeSystem === 'SYSTEM')
                {
                    combinationData = {
                        selectedCombinations: calculationMeta.ticketGroup.systems,
                        total: calculationMeta.countEvent,
                    };
                }
                else if (calculationMeta.codeSystem === 'FIX_SYSTEM')
                {
                    combinationData = {
                        selectedCombinations: calculationMeta.resolveGroups[0].systems,
                        total: (calculationMeta.countEvent - me.fixedEvents),
                    };
                }
            }
            return combinationData;
        },
        payoutDataCalculated()
        {
            const me = this;
            const { status, resolveEstimate, resolve } = me.ticketData.data;

            let payoutCalc = resolveEstimate.calc;
            if (status === 'WIN'
            || status === 'LOST'
            || status === 'REFUND')
            {
                payoutCalc = resolve.calc;
            }

            return payoutCalc;
        },
        ticketDataDateRecieved()
        {
            const me = this;
            const { meta } = me.ticketData.data;

            if (meta.timestampSystem)
            {
                return meta.timestampSystem;
            }

            return meta.global.timestampSystem;
        },
        ticketDataCoefficient()
        {
            const me = this;

            const { resolve } = me.ticketData.data;
            if (resolve !== undefined
            && resolve.calc !== undefined
            && resolve.calc.coefficient !== undefined)
            {
                return resolve.calc.coefficient;
            }
            return null;
        },
        ticketDataPaidOut()
        {
            const me = this;
            let paidOut = false;

            if (me.ticketData.status === 'WIN'
            || me.ticketData.status === 'LOST'
            || me.ticketData.status === 'REFUND')
            {
                if (me.ticketData.payout !== undefined)
                {
                    paidOut = true;
                }
            }
            return paidOut;
        },
        ticketDataPayOffTaxAmount()
        {
            const me = this;
            const { payout, resolve } = me.ticketData.data;
            const payoutCalc = resolve.calc;
            // sum for win tax is returned even if ticket is lost - code  NYA9F4AX8W
            const tempSum = (payoutCalc.taxOnPayout.sum !== undefined) ? payoutCalc.taxOnPayout.sum : 0;

            if (payout !== undefined && payout.sumTaxOnPayout !== undefined)
            {
                return payout.sumTaxOnPayout;
            }

            return tempSum;
        },
        winPerBalls()
        {
            const me = this;
            let val = false;

            if (me.ticketData.data
            && me.ticketData.data.calculationMeta
            && me.ticketData.data.calculationMeta.lottoHitBallWins)
            {
                val = me.ticketData.data.calculationMeta.lottoHitBallWins;
            }
            return val;
        },
        calculateEurConversion()
        {
            return this.globals
                && this.globals.publicConfig
                && this.globals.publicConfig.hrkEurConversion
                && this.globals.publicConfig.hrkEurConversion.enabled;
        },
        ticketType()
        {
            const me = this;

            const { selections } = me.ticketData.data;
            const type = selections.data[0].codeProduct;

            for (const event of selections.data)
            {
                if (type !== event.codeProduct)
                {
                    return 'MIX';
                }
            }

            return selections.data[0].codeProduct;
        },
        lottoResults()
        {
            if (this.ticketType === 'LOTTO')
            {
                if (this.ticketData
                && this.ticketData.data
                && this.ticketData.data.selections
                && this.ticketData.data.selections.data
                && this.ticketData.data.selections.data.length)
                {
                    const [firstSelection] = this.ticketData.data.selections.data;

                    if (firstSelection.attributes
                    && firstSelection.attributes.results)
                    {
                        return firstSelection.attributes.results.split(',');
                    }
                }
            }

            return null;
        },
        displayBarcode()
        {
            if (this.globals
            && this.globals.publicConfig
            && this.globals.publicConfig.website
            && this.globals.publicConfig.website.displayBarcodeOnTicketModal != null)
            {
                return this.globals.publicConfig.website.displayBarcodeOnTicketModal;
            }

            return true;
        },
    },
};
</script>
